<template>
	<not-found-content v-if="$store.state.status !== 200"></not-found-content>
	<div class="boat__info" v-else>
		<!-- Boat Header Info -->
		<div class="boat__header--wrap">
			<div class="boat__header--title">
				<div class="container">
					<div class="inner">
						<h1>Dealer Inventory</h1> <router-link to="/"><span>&#12296;</span> Back To All Inventory</router-link>
					</div>
				</div>
			</div>
		</div>
		<!-- End Boat Header Info -->

		<!-- Boat Details -->
		<div class="boat__details--wrap">
			<div class="container">
				<div class="inner">
					<div class="left">
						<slideshow :images="images" :thumbs="thumbs"></slideshow>
						<div class="pad">
							<div class="title">
								<h3 class="font-bold text-2xl">{{ inventory.boat.name }} Overview</h3>
								<div class="reference">HIN # {{ inventory.hin }}</div>
							</div>
							<div class="details">
								<div class="box">
									<div class="value">{{ inventory.length }}</div>
									<div class="label">Length</div>
								</div>
								<div class="box">
									<div class="value">{{ inventory.beam }}</div>
									<div class="label">Beam</div>
								</div>
								<div class="box">
									<div class="value">{{ inventory.draft }}</div>
									<div class="label">Draft (in)</div>
								</div>
								<div class="box">
									<div class="value">{{ inventory.fuel }}</div>
									<div class="label">Fuel</div>
								</div>
								<div class="box">
									<div class="value">{{ inventory.hp }}</div>
									<div class="label">Max HP</div>
								</div>
							</div>
							<div class="specs__table">
								<div class="feature" v-for="(feature, index) in inventory.specs">
									<div class="label">{{ feature.name }}</div>
									<div class="value">{{ feature.value }}</div>
								</div>
							</div>
							<div class="features__table">
								<div class="features__header"><h3>Custom Options</h3></div>
								<div class="features">
									<div class="feature" v-for="(feature, index) in inventory.features">
										<div class="label">{{ feature.category }} - {{ feature.name }}</div>
										<div class="value">${{ feature.msrp_price }}</div>
									</div>
								</div>
							</div>
							<div class="options__table">
								<div class="options__header">
									<h3>Standard Options</h3>
								</div>
								<div class="options__body">
									<div class="option" v-for="(group, index) in inventory.option_groups" v-if="group.options.length > 0">
										<div class="label">{{ group.name }}</div>
										<div class="description">
											<div v-for="(option, index) in group.options">{{ option.name }}</div>
										</div>
									</div>
								</div>
							</div>
							<dealer-contact :boat="inventory"></dealer-contact>
						</div>
					</div>
					<div class="right">
						<boat-details :inventory="inventory"></boat-details>
					</div>
				</div>
			</div>
		</div>
		<!-- End Details -->
		
	</div>
</template>

<script>
	export default {
		props: ['id'],
		data() {
			return {};
		},
		computed: {
			inventory() {
				return (this.$store.state.data || {boat: []});
			},
			location() {
				return this.$store.state.location;
			},
			images() {
				if(!this.inventory || ((!this.inventory.gallery || this.inventory.gallery.length === 0) && !this.inventory.featured_image)) {
					return ['/images/front/BMT.png'];
				}
				let images = [];
				if(this.inventory.featured_image) {
					images.push(this.inventory.featured_image.thumb600);
				}
				this.inventory.gallery.forEach((image) => {
					images.push(image.thumb600);
				});
				return images;
			},
			thumbs() {
				if(!this.inventory || ((!this.inventory.gallery || this.inventory.gallery.length === 0) && !this.inventory.featured_image)) {
					return ['/images/front/BMT.png'];
				}
				let images = [];
				if(this.inventory.featured_image) {
					images.push(this.inventory.featured_image.thumb100);
				}
				this.inventory.gallery.forEach((image) => {
					images.push(image.thumb100);
				});
				return images;
			},
			seo_desc() {
				return `The ${this.inventory.boat.model_year} ${this.inventory.boat.name} HIN #${this.inventory.hin} | Length: ${this.inventory.length}, Beam: ${this.inventory.beam}, Draft (in): ${this.inventory.draft}, Fuel: ${this.inventory.fuel}, Max HP: ${this.inventory.hp}`;
			}
		},
		methods: {
			async load() {
				this.$store.state.loading++;
				try {
					this.$store.state.data = await this.$get('/json/boats/' + this.id);
					this.$setSeo({
						title: this.inventory.boat.model_year + ' ' + this.inventory.boat.name + ' | ' + this.location?.dealer?.name,
						description: this.seo_desc,
						keywords: 'nauticstar, boats, dealer, inventory',
						image: this.images[0]
					});
				} catch(e) {
					this.$store.state.status = e.code;
				}
				this.$store.state.loading--;
			}
		},
		async serverPrefetch() {
			await this.load();
			this.$store.state.serverFetched = true;
		},
		async mounted() {
			if(this.$store.state.serverFetched) {
				this.$store.state.serverFetched = false;
				return;
			}
			await this.load();
		}
	}
</script>